import { useCallback, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { DataQuery, LabelCategory } from "@models/ISchema";
import { LABELS_CATEGORIES_QUERY } from "../graphql/labelsCategories.queries";

interface UseGetLabelsCategoriesOptionsParams {
  scenario: string;
  campusId?: string;
}

const useGetLabelsCategoriesOptions = ({ scenario }: UseGetLabelsCategoriesOptionsParams) => {
  const client = useApolloClient();
  const [termToSearch, setTermToSearch] = useState("");
  const [labelsCategoriesPage, setLabelsCategoriesPage] = useState(1);

  const requestItems = useCallback(
    async (searchTerm = "", page = 1) => {
      const optionsPerPage = 10;

      try {
        const variables = {
          query: LABELS_CATEGORIES_QUERY,
          variables: {
            scenarioId: scenario,
            filter: {
              pagination: {
                page,
                size: optionsPerPage,
                searchTerm,
              },
            },
          },
        };

        const { data } = await client.query(variables);
        const dataQuery: DataQuery = data.data;
        const pageInfo = dataQuery?.labelCategories?.pageInfo;

        const options =
          dataQuery?.labelCategories?.items?.map((category: LabelCategory) => ({
            label: category.name,
            value: category.id,
          })) ?? [];

        return { pageInfo, options };
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    [client, labelsCategoriesPage],
  );

  const loadOptions = async (newSearchTerm: string) => {
    let searchPage = 1;

    if (termToSearch === newSearchTerm) {
      searchPage = labelsCategoriesPage;
    } else {
      setTermToSearch(newSearchTerm);
    }

    const { pageInfo, options } = await requestItems(newSearchTerm, searchPage);
    setLabelsCategoriesPage(labelsCategoriesPage + 1);

    return {
      options: options,
      hasMore: pageInfo?.hasNextPage,
      additional: { page: labelsCategoriesPage },
    };
  };

  return {
    loadOptions,
  };
};

export default useGetLabelsCategoriesOptions;
